export default ({ product }) => {
  let mode = false
  if (product) {
    const { finalDecision } = product
    const { default_complete_prediction_threshold } = JSON.parse(finalDecision)
    mode =  Boolean(default_complete_prediction_threshold)
  }
  return mode
}
